export default __webpack_public_path__ + "static/media/Pretendard-ExtraBold.subset.035ee0b7.woff2";